import React from 'react';
import { Grid } from '@material-ui/core';

export const SearchInfo = ({ searchResults }) => {
    const hasResults = searchResults && searchResults.nbHits !== 0;
    const nbHits = searchResults && searchResults.nbHits;
    const results = nbHits === 1 ? 'result' : 'results';
    return (
        <Grid container direction="column">
            <div hidden={!hasResults}>
                <b>{nbHits}</b> {results} for "{searchResults ? searchResults.query : ''}"{' '}
            </div>
            <div hidden={hasResults}>
                <p>There are no results for "{searchResults ? searchResults.query : ''}"</p>
                <small>Check your spelling or try another search term</small>
            </div>
        </Grid>
    );
};
